import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-263">
      <div className="max-w-2xl mx-auto text-center" data-id="element-264">
        {/* Shield icon */}
        <div className="text-8xl mb-6" data-id="element-265">🛡️</div>

        <h2 className="text-3xl sm:text-4xl font-black text-[#F97316] mb-4" data-id="element-266">
          GARANTÍA MEGAPACK BOXEO LISTO — 7 DÍAS
        </h2>

        <div className="bg-[#0d0700] border-2 border-[#F97316] rounded-2xl p-8 mb-6" data-id="element-267">
          <p className="text-white text-lg mb-4 leading-relaxed" data-id="element-268">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu próxima clase
            si querés.
          </p>
          <p className="text-white text-lg mb-6 leading-relaxed" data-id="element-269">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-[#F97316] text-3xl font-black mb-4" data-id="element-270">
            Te devolvemos el 100%.
          </p>
          <p className="text-white text-xl font-bold" data-id="element-271">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        <p className="text-gray-400 text-sm leading-relaxed" data-id="element-272">
          La confianza que tenemos en el MegaPack Boxeo Listo nos permite hacer
          esa promesa sin dudar.
          <br data-id="element-273" />
          Más de 500 entrenadores de boxeo de todo el mundo hispanohablante ya
          lo saben.
          <br data-id="element-274" />
          La tasa de devoluciones es menor al 1%.
        </p>
      </div>
    </section>;
}